import { render, staticRenderFns } from "./RadiologyResults.vue?vue&type=template&id=3a6b21e8&"
import script from "./RadiologyResults.vue?vue&type=script&lang=js&"
export * from "./RadiologyResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports